import api from './api';
import publicApi from './publicApi';

export const reservationService = {
  // Check availability for a specific date
  checkAvailability: async (date, outletId = null) => {
    const params = outletId ? { outlet_id: outletId } : {};
    const response = await publicApi.get(`/reservations/availability/${date}`, { params });
    return response.data;
  },

  // Create a new reservation
  createReservation: async (reservationData) => {
    const response = await publicApi.post('/reservations/', reservationData);
    return response.data;
  },

  // Create a booking request (goes to admin for approval)
  createBookingRequest: async (requestData) => {
    const response = await publicApi.post('/booking-request', requestData);
    return response.data;
  },

  // Get user's reservations (if logged in)
  getUserReservations: async () => {
    const response = await api.get('/reservations/my-reservations');
    return response.data;
  },

  // Cancel a reservation
  cancelReservation: async (reservationId) => {
    const response = await api.patch(`/reservations/${reservationId}`, {
      status: 'cancelled'
    });
    return response.data;
  },

  // Get reservation by ID
  getReservation: async (reservationId) => {
    const response = await publicApi.get(`/reservations/${reservationId}`);
    return response.data;
  },

  getReservationPendingRequest: async () => {
    const response = await api.get('/reservations/reservation_count/');
    return response.data
  }
};

export default reservationService;
